import { defineMessages } from 'react-intl';

export default defineMessages({
    textSearchPlaceholderMsg: {
        id: 'portal.views.dashboard-table.service-request.text-search.placeholder_ext',
        defaultMessage: 'Enter a text to filter results based on any of: Request Number, Claim Number, Client\'s name, or Next Step.'
    },
    progressSearchPlaceholderMsg: {
        id: 'portal.views.dashboard-table.service-request.progress-search.placeholder_ext',
        defaultMessage: 'Progress -- All'
    },
    lobSearchPlaceholderMsg: {
        id: 'portal.views.dashboard-table.service-request.lob-search.placeholder_ext',
        defaultMessage: 'LOB -- All'
    },
    serviceTypeSearchPlaceholderMsg: {
        id: 'portal.views.dashboard-table.service-request.serviceType-search.placeholder_ext',
        defaultMessage: 'Service type -- All'
    },
    goToButtonTooltipTitleMsg: {
        id: 'portal.views.dashboard-table.service-request.GoToButton.Tooltip.Title_ext',
        defaultMessage: 'Go to service'
    },
    goToButtonTooltipTextMsg: {
        id: 'portal.views.dashboard-table.service-request.GoToButton.Tooltip.Text_ext',
        defaultMessage: 'Click to go an specific service to see details'
    },
    printButtonTooltipTitleMsg: {
        id: 'portal.views.dashboard-table.service-request.PrintButton.Tooltip.Title_ext',
        defaultMessage: 'Print report'
    },
    printButtonTooltipTextMsg: {
        id: 'portal.views.dashboard-table.service-request.PrintButton.Tooltip.Text_ext',
        defaultMessage: 'Click to generate a report based on start & end date'
    }
});
